import toastService from "../services/ToastService";
import { AttachmentErrors } from "@const/errors";
import { errorLabels } from "@const/validation";
import { getMediaType } from "./files";

const EmojisRegExp =
  /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu;

const getPlainText = (html) => html?.replace(/(<([^>]+)>)/gi, "");

/**
 * Not only spaces validation
 * @param {string} value
 * @returns `false` for invalid, `true` for valid
 */
export const validateOnlySpaces = (value) => {
  return !(value && value?.trim()?.length === 0);
};

/**
 * Not only spaces validation
 * @param {string} value html
 * @returns `false` for invalid, `true` for valid
 */
export const validateHTMLTextNoSpaceOnly = (value) =>
  validateOnlySpaces(getPlainText(value));

/**
 * Not only spaces validation
 * @param {number} max
 * @returns `false` for invalid, `true` for valid
 */
export const validateHTMLTextLength = (max) => (value) =>
  value ? getPlainText(value)?.length <= max : true;

/**
 * Post management attachment validator
 * @param sizes
 * @param {number} sizes.video
 * @param {number} sizes.image
 * @param errors
 * @param translate
 * @returns {(function(*): void)|*}
 */
export const validatePostAttachment =
  (sizes, errors = AttachmentErrors, translate) =>
  (file) => {
    const type = getMediaType(file?.type);
    const maxSize = sizes?.[type];
    if (file.size > maxSize) {
      toastService.error(translate(errors?.[type]?.ATTACHMENT_TOO_LARGE));
      /** need return object for blocking of the attaching files that have not valid size **/
      return {};
    }
  };

/**
 * Get error label from form label
 * @param {string} label
 */
export const getErrorLabel = (label) => errorLabels[label] ?? label;

/**
 *  Check if text length is valid
 * @param {string} value
 * @param {number} maxLength
 * @returns {*|number}
 */
export const getMaxLength = (value, maxLength) => {
  if (value === undefined) {
    return 0;
  }
  const emojisCount = value?.match
    ? (value?.match(EmojisRegExp) || []).length
    : 0;

  const maxLengthWithEmojis = maxLength + emojisCount;
  const emojisMaxLength = maxLength * 2;

  if (maxLengthWithEmojis >= emojisMaxLength) {
    return maxLength * 2;
  }
  return maxLengthWithEmojis;
};
